import { useEffect, useState } from "react"
import { Dcs0201Service } from "../../../services/dcs/Dcs0201Service"

export default function SelectProVer(props:any) {

    const [lstData, setLstData] = useState<any>([])

    useEffect(()=>{
        _getLstProVer()
        console.log(props);
        
    },[])

    function _getLstProVer(){
        Dcs0201Service.getInstance().getProVer().then((result:any)=>{
            console.log(result);
            if(result.data.status){
                setLstData(result.data.responseData)
            }
        })

    }

    const onSelect = (selected:any)=>{
        console.log(selected);
        props.onClose(selected)
    }
    return (
        <>
            {lstData && lstData.map((element:any, index:number)=>(
                <div className={`card card-body ${index === lstData.length-1 ? "mb-0" : "mb-3"} prover-select ${props.selected && props.selected?.versionId === element.versionId ? "prover-slt" : ""}`}  key={element.id} onClick={()=> onSelect(element)}>
                    {element.protocolName} - {element.protocolVersion}
                </div>
            ))}
        </>
    )
}